module.exports = __webpack_public_path__ + "assets/img/triangle.0962f313.svg";